import { mapMutations } from 'vuex';

export default {
  data() {
    return {
    };
  },

  methods: {
    ...mapMutations('ui', {
      uiToggleDialog: 'TOGGLE_DIALOG',
      uiSetDialogContent: 'SET_DIALOG_CONTENT',
      uiSetDialogTitle: 'SET_DIALOG_TITLE',
      uiChangeValue: 'CHANGE_VALUE',
      uiShowBottomModal: 'SHOW_BOTTOM_MODAL',
    }),
    // metodo para mostrar el formulario del documento vacio
    showEmptyForm() {
      this.uiChangeValue({
        varName: 'modalWidth',
        value: '50%',
      });
      this.uiChangeValue({
        varName: 'showModalOptions',
        value: false,
      });
      this.uiChangeValue({
        varName: 'currentProperties',
        value: {
          annotationData: {
          },
          annotationId: ''
        },
      });
      this.uiSetDialogContent('DocumentForm');
      this.uiSetDialogTitle('Cargar documento en el sistema');
      this.uiToggleDialog(true);
    },
    // metodo para mostar el documento de la anotacion
    showAnnotationDocument(annotation) {
      const title = `Documento para la anotación <b>${annotation.numero}</b>:
        ${document.nombre} de ${document.entidad_emisora}`;
      this.uiShowBottomModal({
        dialogTitle: title,
        componentName: 'FolioVisor',
        properties: {
          folioUrl: annotation.archivo.url,
        }
      });
    },
    // metodo para mostar el documento desde el listado de documentos
    showDocument(document) {
      const title = `${document.nombre} de ${document.entidad_emisora}`;
      this.uiShowBottomModal({
        dialogTitle: title,
        componentName: 'FolioVisor',
        properties: {
          folioUrl: document.url,
        },
      });
    },
    // metodo para ir a la vista del detalle del documento
    detailDocument(documentId) {
      this.$router.push({
        name: 'DocumentDetail',
        params: {documentId}
      });
    },
  }
};